/**
 * @public
 */
export var DateField;
(function (DateField) {
    DateField["ERA"] = "era";
    DateField["YEAR"] = "year";
    DateField["QUARTER"] = "quarter";
    DateField["MONTH"] = "month";
    DateField["WEEK"] = "week";
    DateField["WEEK_OF_MONTH"] = "weekOfMonth";
    DateField["DAY"] = "day";
    DateField["DAY_OF_YEAR"] = "dayOfYear";
    DateField["WEEKDAY"] = "weekday";
    DateField["WEEKDAY_OF_MONTH"] = "weekdayOfMonth";
    DateField["SUN"] = "sun";
    DateField["MON"] = "mon";
    DateField["TUE"] = "tue";
    DateField["WED"] = "wed";
    DateField["THU"] = "thu";
    DateField["FRI"] = "fri";
    DateField["SAT"] = "sat";
    DateField["DAY_PERIOD"] = "dayperiod";
    DateField["HOUR"] = "hour";
    DateField["MINUTE"] = "minute";
    DateField["SECOND"] = "second";
    DateField["ZONE"] = "zone";
})(DateField || (DateField = {}));
/**
 * @public
 */
export var DateFieldWidth;
(function (DateFieldWidth) {
    DateFieldWidth["SHORT"] = "short";
    DateFieldWidth["NARROW"] = "narrow";
    DateFieldWidth["WIDE"] = "wide";
})(DateFieldWidth || (DateFieldWidth = {}));
/**
 * @public
 */
export var RelativeTimeField;
(function (RelativeTimeField) {
    RelativeTimeField["YEAR"] = "year";
    RelativeTimeField["QUARTER"] = "quarter";
    RelativeTimeField["MONTH"] = "month";
    RelativeTimeField["WEEK"] = "week";
    RelativeTimeField["DAY"] = "day";
    RelativeTimeField["SUN"] = "sun";
    RelativeTimeField["MON"] = "mon";
    RelativeTimeField["TUE"] = "tue";
    RelativeTimeField["WED"] = "wed";
    RelativeTimeField["THU"] = "thu";
    RelativeTimeField["FRI"] = "fri";
    RelativeTimeField["SAT"] = "sat";
    RelativeTimeField["HOUR"] = "hour";
    RelativeTimeField["MINUTE"] = "minute";
    RelativeTimeField["SECOND"] = "second";
})(RelativeTimeField || (RelativeTimeField = {}));
//# sourceMappingURL=datefields.js.map